// extracted by mini-css-extract-plugin
export default {"messageContainer":"EmptyArticlesListMessage_messageContainer__GwK+q","messageImage":"EmptyArticlesListMessage_messageImage__msZxB"};